/**
 * Feedback Taxonomy
 * 
 * Complete taxonomy for feedback categories and subcategories.
 * Used for frontend AI integration and validation.
 */

export const FEEDBACK_TAXONOMY = {
  categories: [
    'Cabin',
    'Restaurant',
    'Bar',
    'Lounge',
    'Boarding',
    'Onboard Experience',
    'Offboard Experience',
    'Service',
    'General Experience',
  ],

  subcategories: {
    'Cabin': [
      'Bathroom',
      'Bed',
      'Temperature',
      'Comfort',
    ],

    'Restaurant': [
      'Food & Beverage',
      'Timings',
      'Service',
      'Temperature',
      'Restaurant Staff',
      'Menu',
    ],

    'Bar': [
      'Choice',
      'Comfort',
      'Ambience',
      'Service',
    ],

    'Lounge': [
      'Comfort',
      'Ambience',
      'Service',
      'Welcome',
      'Food & Beverage',
      'Entertainment',
    ],

    'Boarding': [
      'Convenience',
      'Comfort',
      'Service',
      'Welcome',
    ],

    'Onboard Experience': [
      'Crew Bar',
      'Crew Restaurant',
      'Conductor',
      'Train Manager',
      'Entertainment',
      'Special Events',
      'Train Design',
    ],

    'Offboard Experience': [
      'Restaurants',
      'Experience',
      'Transfers',
      'Local Guide',
      'Length',
      'Quality',
      'Service & Guest Support',
      'Value for Money',
      'Content',
    ],

    'Service': [
      'Guest Communication',
      'Transfer',
    ],

    'General Experience': [], // No subcategories
  },

  importanceLevels: [
    'High',
    'Medium',
    'Low',
  ] as const,
};

export type FeedbackCategory = typeof FEEDBACK_TAXONOMY.categories[number];
export type FeedbackSubcategory = typeof FEEDBACK_TAXONOMY.subcategories[keyof typeof FEEDBACK_TAXONOMY.subcategories][number];
export type FeedbackImportance = typeof FEEDBACK_TAXONOMY.importanceLevels[number];
